<div class="page">
    <div class="page-head">
        <div>
            <h2>{{ pageTitle() }}</h2>
            <p>Manage zones (e.g. "Zonal Office 6") used to group a client's regional offices.</p>
        </div>
        <p-button label="Add Zone" icon="pi pi-plus" (onClick)="openAdd()" />
    </div>

    <div class="card">
        <div class="toolbar">
            <p-iconfield iconPosition="left" class="search-field">
                <p-inputicon styleClass="pi pi-search" />
                <input type="text" pInputText placeholder="Search zone..."
                    [ngModel]="search()" (ngModelChange)="search.set($event)">
            </p-iconfield>
            <span class="count">{{ filtered().length }} of {{ rows().length }}</span>
        </div>

        <p-table [value]="filtered()" [loading]="loading()" dataKey="id" [rows]="10"
            [paginator]="filtered().length > 10" [rowsPerPageOptions]="[10, 25, 50]"
            styleClass="p-datatable-sm" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
            <ng-template pTemplate="header">
                <tr>
                    <th>Zone</th>
                    <th>Status</th>
                    <th class="ta-r">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-r>
                <tr>
                    <td class="name">{{ r.zoneName }}</td>
                    <td>
                        <p-tag [value]="r.isActive ? 'ACTIVE' : 'INACTIVE'"
                            [severity]="r.isActive ? 'success' : 'secondary'"
                            (click)="toggleActive(r)" styleClass="clickable" pTooltip="Click to toggle" />
                    </td>
                    <td class="ta-r actions">
                        <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary"
                            pTooltip="Edit" (onClick)="openEdit(r)" />
                        <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
                            pTooltip="Delete" (onClick)="remove(r)" />
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="3">
                        <div class="state"><i class="pi pi-inbox"></i><p>No zones found.</p></div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- ===================== ADD / EDIT MODAL ===================== -->
<p-dialog [visible]="showModal()" (visibleChange)="showModal.set($event)" [modal]="true"
    [draggable]="true" [resizable]="false" [closable]="true" [dismissableMask]="false"
    [header]="editing() ? 'Edit Zone' : 'Add Zone'" styleClass="menu-dialog"
    [style]="{ width: '460px' }" [breakpoints]="{ '460px': '94vw' }">
    <form [formGroup]="form" class="menu-form">
        <div class="field">
            <label>Zone Name <span class="req">*</span></label>
            <input pInputText type="text" formControlName="zoneName" placeholder="e.g. Zonal Office 6">
            @if (form.get('zoneName')?.touched && form.get('zoneName')?.invalid) {
                <small class="err">Zone name is required</small>
            }
        </div>

        <div class="field-row">
            <label>Active</label>
            <p-toggleswitch formControlName="isActive" />
        </div>

        <div class="modal-actions">
            <p-button label="Cancel" [outlined]="true" (onClick)="closeModal()" />
            <p-button label="Save" (onClick)="save()" [loading]="saving()" />
        </div>
    </form>
</p-dialog>
